// ════════════════════════════════════════════════════════════
// Tooltip ECR — primitive Radix légère (Sprint Shell)
// ════════════════════════════════════════════════════════════
// Ajout micro-primitive : la sidebar repliée a besoin d'un tooltip
// pour les libellés masqués. Token-stylé, respecte reduced-motion.
//
// Anatomie : TooltipProvider · Tooltip · TooltipTrigger · TooltipContent.
// ════════════════════════════════════════════════════════════
import * as React from 'react';
import * as RadixTooltip from '@radix-ui/react-tooltip';
import { cn } from '@/lib/utils';

const TooltipProvider = RadixTooltip.Provider;
const Tooltip = RadixTooltip.Root;
const TooltipTrigger = RadixTooltip.Trigger;

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof RadixTooltip.Content>,
  React.ComponentPropsWithoutRef<typeof RadixTooltip.Content>
>(({ className, sideOffset = 6, ...props }, ref) => (
  <RadixTooltip.Portal>
    <RadixTooltip.Content
      ref={ref}
      sideOffset={sideOffset}
      className={cn(
        'bg-popover text-popover-foreground border-border z-50 overflow-hidden rounded-md border px-2.5 py-1.5 text-xs font-medium shadow-md',
        'data-[state=delayed-open]:animate-in data-[state=closed]:animate-out',
        'data-[state=closed]:fade-out-0 data-[state=delayed-open]:fade-in-0',
        'data-[state=delayed-open]:zoom-in-95 data-[state=closed]:zoom-out-95',
        'motion-reduce:animate-none motion-reduce:duration-0',
        className,
      )}
      {...props}
    />
  </RadixTooltip.Portal>
));
TooltipContent.displayName = 'TooltipContent';

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
